let config = {
  // url:"http://192.168.1.131:8181/psx/"
  url:"https://api.paishouxiao.cn/psx/"
}

export default config;



//////////////////
// WEBPACK FOOTER
// ./config/config.js
// module id = null
// module chunks = 